export default __webpack_public_path__ + "static/media/borad.3a339880.png";